var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('top-block'),_c('avo-blocks'),_c('pref-block'),_c('install-block'),_c('promo-block')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }